/** Build query params from a homepage quick-filter preset. */
export const presetToParams = (preset = {}) => {
    const q = new URLSearchParams();
    if (preset.category) q.set("category", preset.category);
    if (preset.subcategory) q.set("subcategory", preset.subcategory);
    if (preset.fuel_type) q.set("fuel_type", preset.fuel_type);
    if (preset.brand) q.set("brand", preset.brand);
    if (preset.price_min) q.set("price_min", String(preset.price_min));
    if (preset.price_max) q.set("price_max", String(preset.price_max));
    if (preset.sort) q.set("sort", preset.sort);
    q.set("is_upcoming", "false");
    if (preset.featured_only) q.set("is_featured", "true");
    return q;
};

export const presetKey = (preset = {}) =>
    JSON.stringify({
        category: preset.category || "",
        subcategory: preset.subcategory || "",
        fuel_type: preset.fuel_type || "",
        brand: preset.brand || "",
        price_min: preset.price_min || "",
        price_max: preset.price_max || "",
        sort: preset.sort || "",
        featured_only: Boolean(preset.featured_only),
    });

const BUDGET_BANDS = [
    { id: "u1", label: "Under ₹1L", price_max: "100000", sort: "price_asc" },
    { id: "1-2", label: "₹1L–₹2L", price_min: "100000", price_max: "200000" },
];

/** Merge CMS chips + live inventory signals; drop empty bands, cap total. */
export const buildSmartChips = (cmsFilters = [], meta = {}, { max = 8, smartBrands = true } = {}) => {
    const out = [];
    const seen = new Set();

    const push = (chip) => {
        const key = chip.id || presetKey(chip);
        if (seen.has(key)) return;
        if (chip.minCount != null && (chip.count ?? 0) < chip.minCount) return;
        seen.add(key);
        out.push(chip);
    };

    (Array.isArray(cmsFilters) ? cmsFilters : []).forEach((f) => push({ ...f, id: f.id || presetKey(f) }));

    if (smartBrands && meta.brands) {
        Object.entries(meta.brands)
            .sort((a, b) => b[1] - a[1])
            .slice(0, 4)
            .forEach(([brand, count]) => {
                if (out.some((c) => c.brand === brand)) return;
                push({ id: `brand-${brand}`, label: brand, brand, count, smart: true });
            });
    }

    if (meta.budget_bands) {
        meta.budget_bands.forEach((b) => {
            if (out.some((c) => c.id === b.id)) return;
            if (b.count > 0) push({ ...b, smart: true, count: b.count });
        });
    } else {
        BUDGET_BANDS.forEach((b) => push({ ...b, smart: true }));
    }

    if ((meta.fuel_counts?.Electric ?? 0) > 0 && !out.some((c) => c.fuel_type === "Electric")) {
        push({ id: "ev", label: "Electric", fuel_type: "Electric", count: meta.fuel_counts.Electric, smart: true });
    }

    if ((meta.featured_count ?? 0) > 0 && !out.some((c) => c.featured_only)) {
        push({ id: "featured", label: "Deals", featured_only: true, count: meta.featured_count, smart: true });
    }

    return out.slice(0, max);
};
